export const DB_NODES = {
  ACTIVE: "active",
  ALBUMS: "albums",
  CATEGORIES: "categories",
  CITY_ID: "city_id",
  COLOR: "color",
  DATE: "date",
  FROM: "from",
  FWC_2022: "FWC_2022",
  FWWC_2023: "FWWC_2023",
  MISSING: "missing",
  NAME: "name",
  NAME_L10N: "nameL10n",
  NOTIFICATION_ID: "notificationId",
  NOTIFICATIONS: "notifications",
  PHONE_NUMBER: "phoneNumber",
  PHONE_NUMBER_SHARING: "phone_number_sharing",
  PUSH_NOTIFICATION_TOKENS: "push_notification_tokens",
  READ: "read",
  REPEATED: "repeated",
  SHARED_WITH: "sharedWith",
  STICKERS: "stickers",
  TO: "to",
  TOKENS: "tokens",
  TYPE: "type",
  USERS: "users",
  USER_ALBUMS: "user_albums",
  USER_BLOCKAGES: "userBlockages",
};
